
import { Vue, Component } from "vue-property-decorator";
import { regionData } from "element-china-area-data";
import areaArr from "@/components/world.js";
@Component({
  name: "editBalance",
})	
export default class editBalance extends Vue {
	
  data() {
    return {
		data:{
			name: "",
			phone: "",
			profile: "",
			sex: "",
			addr: "",
			type: "",
			password: "",
			enable: "",
			email: "",
			updateTime:"",
		},
		url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
		value: [[17,18,19],[1,7,10],[1,2,3]],
		options : regionData,
		selectedOptions:[],
		areaArr:areaArr,
		radio: '2'
	}
  };
  private onCancel(){
	  
	  console.log('取消')
	  this.$router.back();
  }
  private onSubmit() {
    console.log(this.data);
  };
  private handleChange(value){
	  
	  console.log('ddd',value);
  };
  private mounted(){
	  
	console.log('radio');
  }
}
	
